module.exports = __webpack_public_path__ + "img/33_52.97ea9acc.png";